var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"hide-details":"","single-line":"","outlined":"","dense":"","items":_vm.countries,"value":_vm.value},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }